import { useEffect, useState } from "react";

declare global {
  interface Window {
    YT: any;
    onYouTubeIframeAPIReady: () => void;
  }
}

export const useYouTubeAPI = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Check if API is already loaded and ready
    if (window.YT && window.YT.Player) {
      setIsReady(true);
      return;
    }

    // Set up the callback for when API is ready
    const originalCallback = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      setIsReady(true);
      if (originalCallback) originalCallback();
    };

    // Load the API script if not already present
    if (!document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
    } else {
      // Script exists, poll for YT.Player availability
      const checkInterval = setInterval(() => {
        if (window.YT && window.YT.Player) {
          setIsReady(true);
          clearInterval(checkInterval);
        }
      }, 100);

      return () => clearInterval(checkInterval);
    }
  }, []);

  return isReady;
};
